import React from 'react';
import { connect } from 'react-redux';
import CanvasJSChart from '../CanvasJSChart';
import LoadingControl from '../../../LoadingControl';
import { colors } from '../../../../constants';

class StackedBar100Chart extends React.Component {
    render() {
        const { propId, dataPoints } = this.props;
        //if (!dataPoints || !Array.isArray(dataPoints))
        //    return (<LoadingControl />);

        //let colorsSet = colors ? colors : [orange, green, purple, purple1, purple2, purple3, purple4, purple5 ];

        //const dataPointsToUse =
        //    [
        //        { label: "Health & Clinical Science", y: 85 },
        //        { label: "Education", y: 79 },
        //        { label: "Psyhcology", y: 77 },
        //        { label: "Language & Literature", y: 68 },
        //        { label: "Communication Tech", y: 63 },
        //        { label: "Art", y: 61 },
        //        { label: "Biomedical Science", y: 59 },
        //        { label: "Social Science & History", y: 49 },
        //        { label: "Business", y: 49 },
        //        { label: "Computer & Info Science", y: 18 }
        //    ]

        //    dataPoints.map(dataPoint => {
        //    return {
        //        //indexLabel: " ",
        //        //indexLabelLineColor: "white",
        //        label: dataPoint.label,
        //        y: dataPoint.value,
        //        color: dataPoint.color
        //    };
        //});

        const options = {
            colorSet: 'Zacoustic',
            animationEnabled: true,
            title: {
                text: ""
            },
            axisY: {
                title: "",
                suffix: "%"
            },
            labelFontSize: '36px',
            legend: {
                verticalAlign: "center",
                horizontalAlign: "right",
                cursor: "pointer",
                fontSize: 14,
                fontFamily: 'Roboto',
                fontWeight: 400,
                itemclick: this.toggleDataSeries
            },
            toolTip: {
                shared: true
            },
            data: [
                {
                    type: "stackedColumn100",
                    name: "Met",
                    showInLegend: true,
                    color: colors.correctGreen,
                    dataPoints: [
                        { label: "Attribute1", y: 1118 },
                        { label: "-" },
                        { label: "Attribute2", y: 473 },
                        { label: "-" },
                        { label: "Attribute3", y: 273 },
                        { label: "-" },
                        { label: "Attribute4", y: 243 },
                        { label: "-" },
                        { label: "Attribute5", y: 269 },
                        { label: "-"  },
                        { label: "Attribute6", y: 243 },
                        { label: "-"  },
                        { label: "Attribute7", y: 195 },
                        { label: "-"  },
                        { label: "Attribute8", y: 236 },
                        { label: "-"  },
                        { label: "Attribute9", y: 194 },
                        { label: "-"  },
                        { label: "Attribute10", y: 192 },
                        { label: "-"  },
                    ]
                },
                {
                    type: "stackedColumn100",
                    name: "N/A",
                    showInLegend: true,
                    color: colors.neutralGrey,
                    dataPoints: [
                        { label: "Attribute1", y: 897 },
                        { label: "-"  },
                        { label: "Attribute2", y: 376 },
                        { label: "-"  },
                        { label: "Attribute3", y: 299 },
                        { label: "-"  },
                        { label: "Attribute4", y: 72 },
                        { label: "-"  },
                        { label: "Attribute5", y: 272 },
                        { label: "-"  },
                        { label: "Attribute6", y: 2 },
                        { label: "-"  },
                        { label: "Attribute7", y: 10 },
                        { label: "-"  },
                        { label: "Attribute8", y: 9 },
                        { label: "-"  },
                        { label: "Attribute9", y: 56 },
                        { label: "-"  },
                        { label: "Attribute10", y: 165 },
                        { label: "-"  },
                    ]
                },
                {
                    type: "stackedColumn100",
                    name: "Did not meet",
                    showInLegend: true,
                    color: colors.incorrectRed,
                    dataPoints: [
                        { label: "Attribute1", y: 789 },
                        { label: "-"  },
                        { label: "Attribute2", y: 355 },
                        { label: "-"  },
                        { label: "Attribute3", y: 303 },
                        { label: "-"  },
                        { label: "Attribute4", y: 10 },
                        { label: "-"  },
                        { label: "Attribute5", y: 283 },
                        { label: "-"  },
                        { label: "Attribute6", y: 6 },
                        { label: "-"  },
                        { label: "Attribute7", y: 33 },
                        { label: "-"  },
                        { label: "Attribute8", y: 4 },
                        { label: "-"  },
                        { label: "Attribute9", y: 87 },
                        { label: "-"  },
                        { label: "Attribute10", y: 162 },
                        { label: "-"  },
                    ]
                }
            ]
        };

        return (
            <CanvasJSChart
                chartContainerId="5"
                options={options}
                containerProps={{ height: '100%', width: '100%' }}
            />
        );
    }
}

const select = state => ({});

export default connect(select)(StackedBar100Chart);
